import { HttpClient } from '@store/base';
import {
  CancelAsCareRequest,
  CancelAsCareResponse,
  CompleteAsCareApplyRequest,
  CompleteAsCareApplyResponse,
  GetAsCareApplySheetRequest,
  GetAsCareApplySheetResponse,
  GetAsCareCancelListResponse,
  GetAsCareListResponse,
  GetAsCarePayRequestRequest,
  GetAsCarePayRequestResponse,
} from '../../model/dto/as-care';

/**
 * 한샘 AS케어+ (연장보증보험) Base Gateway — order-service `한샘몰 AS케어+`.
 *
 * API 호출만 담당한다. 화면용 모양으로 바꾸는 일은 di-container 래퍼가 맡는다.
 */

const BASE_URL = `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/order-service/api/mall/v1/as-care`;

/**
 * 보험신청/내역 조회 (SC-02).
 * 신청가능·가입완료·신청불가 3개 탭을 한 번에 받는다 — 페이지네이션이 없다.
 */
export class GetAsCareListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetAsCareListResponse>({
      method: 'GET',
      url: BASE_URL,
    });
  }
}

/** 보험신청서 조회 (SC-03) */
export class GetAsCareApplySheetGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAsCareApplySheetRequest) {
    return await this.httpClient.request<GetAsCareApplySheetResponse>({
      method: 'POST',
      url: `${BASE_URL}/apply-sheet`,
      body: req,
    });
  }
}

/**
 * 보험료 결제요청 파라미터 조회 (SC-04 Step 2).
 * 서버가 PG 를 호출하지는 않는다 — 결제창에 넘길 파라미터를 서명해서 내려줄 뿐이다.
 */
export class GetAsCarePayRequestGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAsCarePayRequestRequest) {
    return await this.httpClient.request<GetAsCarePayRequestResponse>({
      method: 'POST',
      url: `${BASE_URL}/pay-request`,
      body: req,
    });
  }
}

/**
 * 보험신청 확정 (SC-05).
 * PG 인증결과를 넘기면 서버가 승인까지 처리하고 가입을 확정한다.
 */
export class CompleteAsCareApplyGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CompleteAsCareApplyRequest) {
    return await this.httpClient.request<CompleteAsCareApplyResponse>({
      method: 'POST',
      url: `${BASE_URL}/apply-complete`,
      body: req,
    });
  }
}

/**
 * 보험취소 접수 (SC-07).
 * PG 취소가 실패하면 접수되지 않는다 — 고객이 재시도할 수 있어야 하기 때문이다.
 */
export class CancelAsCareGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CancelAsCareRequest) {
    return await this.httpClient.request<CancelAsCareResponse>({
      method: 'POST',
      url: `${BASE_URL}/cancels`,
      body: req,
    });
  }
}

/** 보험취소/내역 조회 (SC-08) */
export class GetAsCareCancelListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetAsCareCancelListResponse>({
      method: 'GET',
      url: `${BASE_URL}/cancels`,
    });
  }
}
